import { inject, Injectable } from '@angular/core';
import { SchadenOrtZeit } from '@gsm/entities';
import {
  DYNAMIC_FORM_CONTROL_TYPE_ARRAY, DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX, DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX_GROUP, DYNAMIC_FORM_CONTROL_TYPE_COLORPICKER, DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER, DYNAMIC_FORM_CONTROL_TYPE_EDITOR, DYNAMIC_FORM_CONTROL_TYPE_FILE_UPLOAD, DYNAMIC_FORM_CONTROL_TYPE_GROUP, DYNAMIC_FORM_CONTROL_TYPE_INPUT, DYNAMIC_FORM_CONTROL_TYPE_RADIO_GROUP, DYNAMIC_FORM_CONTROL_TYPE_RATING, DYNAMIC_FORM_CONTROL_TYPE_SELECT, DYNAMIC_FORM_CONTROL_TYPE_SLIDER, DYNAMIC_FORM_CONTROL_TYPE_SWITCH, DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA, DYNAMIC_FORM_CONTROL_TYPE_TIMEPICKER, DynamicCheckboxGroupModel, DynamicCheckboxModel, DynamicColorPickerModel, DynamicDatePickerModel, DynamicEditorModel, DynamicFileUploadModel, DynamicFormArrayGroupModel, DynamicFormArrayModel, DynamicFormComponentService, DynamicFormControlModel, DynamicFormGroupModel, DynamicFormModel, DynamicFormService, DynamicFormValidationService, DynamicInputModel, DynamicRadioGroupModel, DynamicRatingModel, DynamicSelectModelConfig, DynamicSliderModel, DynamicSwitchModel, DynamicTextAreaModel, DynamicTimePickerModel, maskFromString, parseReviver
} from '@ng-dynamic-forms/core';
import equal from 'fast-deep-equal';
import { AbschlussComponentModel, TYPE_ABSCHLUSS } from './dynamic-form-components/abschluss/abschluss.model';
import { ActionButtonModel, TYPE_ACTION_BUTTON } from './dynamic-form-components/action-button/action-button.model';
import { ChecklisteModel, TYPE_CHECKLISTE } from './dynamic-form-components/checkliste/checkliste.model';
import { ChipChoiceAutocompleteModel, TYPE_CHIP_CHOICE_AUTOCOMPLETE } from './dynamic-form-components/chip-choice-autocomplete/chip-choice-autocomplete.model';
import { ChipChoiceMultipleModel, TYPE_CHIP_CHOICE_MULTIPLE } from './dynamic-form-components/chip-choice-multiple/chip-choice-multiple.model';
import { CollisionPickerModel, TYPE_COLLISION_PICKER } from './dynamic-form-components/collision-picker/collision-picker.model';
import { CustomFileUploadModel, TYPE_CUSTOM_FILE_UPLOAD } from './dynamic-form-components/custom-file-upload/custom-file-upload.model';
import { DataArrayModel, TYPE_DATA_ARRAY } from './dynamic-form-components/data-array/data-array.model';
import { DateRangePickerModel, TYPE_DATE_RANGE_PICKER } from './dynamic-form-components/date-range-picker/date-range-picker.model';
import { DokumentenAngabeModel, TYPE_DOKUMENTEN_ANGABE } from './dynamic-form-components/dokumenten-angabe/dokumenten-angabe.model';
import { EigenleistungTableModel, TYPE_EIGENLEISTUNG_TABLE } from './dynamic-form-components/eigenleistung-table/eigenleistung-table.model';
import { FahrradListeModel, TYPE_FAHRRAD_LISTE } from './dynamic-form-components/fahrrad-liste/fahrrad-liste.model';
import { GebaeudeSchadenModel, TYPE_GEBAEUDE_SCHADEN } from './dynamic-form-components/gebaeude-schaden/gebaeude-schaden.model';
import { GeschaedigteGeraeteEinfachModel, TYPE_GESCHAEDIGTE_GERAETE_EINFACH } from './dynamic-form-components/geschaedigte-geraete-einfach/geschaedigte-geraete-einfach.model';
import { GeschaedigteGeraeteKomplexModel, TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX } from './dynamic-form-components/geschaedigte-geraete-komplex/geschaedigte-geraete-komplex.model';
import { GeschaedigtesFahrzeugModel, TYPE_GESCHAEDIGTES_FAHRZEUG } from './dynamic-form-components/geschaedigtes-fahrzeug/geschaedigtes-fahrzeug.model';
import { HaftpflichtForderungAufstellungModel, TYPE_HAFTPFLICHT_FORDERUNG_AUFSTELLUNG } from './dynamic-form-components/haftpflicht-forderung-aufstellung/haftpflicht-forderung-aufstellung.model';
import { HaftpflichtGeschaedigtePersonModel, TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON } from './dynamic-form-components/haftpflicht-geschaedigte-person/haftpflicht-geschaedigte-person.model';
import { HaftpflichtKfzSchadenModel, TYPE_HAFTPFLICHT_KFZ_SCHADEN } from './dynamic-form-components/haftpflicht-kfz-schaden/haftpflicht-kfz-schaden.model';
import { HaftpflichtPersonenschadenModel, TYPE_HAFTPFLICHT_PERSONENSCHADEN } from './dynamic-form-components/haftpflicht-personenschaden/haftpflicht-personenschaden.model';
import { HaftpflichtSachschadenHandyModel, TYPE_HAFTPFLICHT_SACHSCHADEN_HANDY } from './dynamic-form-components/haftpflicht-sachschaden-handy/haftpflicht-sachschaden-handy.model';
import { HaftpflichtSachschadenKabelLeitungModel, TYPE_HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG } from './dynamic-form-components/haftpflicht-sachschaden-kabel-leitung/haftpflicht-sachschaden-kabel-leitung.model';
import { HaftpflichtSachschadenWaldarbeitenModel, TYPE_HAFTPFLICHT_SACHSCHADEN_WALDARBEITEN } from './dynamic-form-components/haftpflicht-sachschaden-waldarbeiten/haftpflicht-sachschaden-waldarbeiten.model';
import { HaftpflichtSpritzWaldarbeitenAufstellungModel, TYPE_HAFTPFLICHT_SPRITZ_WALDARBEITEN_AUFSTELLUNG } from './dynamic-form-components/haftpflicht-spritz-waldarbeiten-aufstellung/haftpflicht-spritz-waldarbeiten-aufstellung.model';
import { HaftpflichtTierschadenModel, TYPE_HAFTPFLICHT_TIERSCHADEN } from './dynamic-form-components/haftpflicht-tierschaden/haftpflicht-tierschaden.model';
import { InfoComponentModel, TYPE_INFO } from './dynamic-form-components/info/info.model';
import { InventaraufstellungTableModel, TYPE_INVENTARAUFSTELLUNG_TABLE } from './dynamic-form-components/inventaraufstellung-table/inventaraufstellung-table.model';
import { KontaktAngabeModel, TYPE_KONTAKT_ANGABE } from './dynamic-form-components/kontakt-angabe/kontakt-angabe.model';
import { LenkerAuswaehlenModel, TYPE_LENKER_AUSWAEHLEN } from './dynamic-form-components/lenker-auswaehlen/lenker-auswaehlen.model';
import { NachrichtReferentModel, TYPE_NACHRICHT_REFERENT } from './dynamic-form-components/nachricht-referent/nachricht-referent.model';
import { NachrichtenverlaufModel, TYPE_NACHRICHTENVERLAUF } from './dynamic-form-components/nachrichtenverlauf/nachrichtenverlauf.model';
import { SchadenAngabeModel, TYPE_SCHADEN_ANGABE } from './dynamic-form-components/schaden-angabe/schaden-angabe.model';
import { SchadenbeteiligterKontaktErfassenModel, TYPE_SCHADENBETEILIGTER_KONTAKT_ERFASSEN } from './dynamic-form-components/schadenbeteiligter-kontakt-erfassen/schadenbeteiligter-kontakt-erfassen.model';
import { SelectEditModel, TYPE_SELECT_EDIT } from './dynamic-form-components/select-edit/select-edit.model';
import { SelectFilterModel, TYPE_SELECT_FILTER } from './dynamic-form-components/select-filter/select-filter.model';
import { CustomDynamicSelectModel, CustomDynamicSelectModelConfig } from './dynamic-form-components/shared-models/custom-dynamic-select.model';
import { TYPE_ZAHLUNGSEMPFAENGER, ZahlungsempfaengerModel } from './dynamic-form-components/zahlungsempfaenger/zahlungsempfaenger.model';
import { compareProps } from './helpers/compare-props.helper';

const OPTION_MATCHERS: Record<string, (a, b) => boolean> = {
  schadenOrt: (a: SchadenOrtZeit, b: SchadenOrtZeit) =>
                // If vorhanden is 'A' (Erfassen) or 'B' (Siehe Beilage) don't bother to compare adresseId
                compareProps(['vorhanden'], a, b) && (/^(A|B)$/.test(a?.vorhanden) || compareProps(['adresse.adresseId'], a, b)),
  vorUndNachname: (a, b) => compareProps([
    'vorname',
    'nachname'
  ], a, b, true)
} as const;

const DISPLAY_LABEL_FNS: Record<string, (value) => string> = {
  beschreibung: val => val.beschreibung
} as const;

@Injectable({
  providedIn: 'root'
})
export class CustomDynamicFormService extends DynamicFormService {

  constructor() {
    const componentService = inject(DynamicFormComponentService);
    const validationService = inject(DynamicFormValidationService);

    super(componentService, validationService);
  }

  // Needs to be first method in order for schematics to work
  fromJSON(json: string | object[]): DynamicFormModel | never {
    const rawFormModel = typeof json === 'string' ? JSON.parse(json, parseReviver) : json;
    const formModel: DynamicFormModel = [];

    rawFormModel.forEach((modelConfig: any) => {
      const layout = modelConfig.layout || null;
      let model: DynamicFormModel | DynamicFormControlModel;

      switch (modelConfig.type) {
        case DYNAMIC_FORM_CONTROL_TYPE_ARRAY:
          const formArrayModel = modelConfig as DynamicFormArrayModel;

          if (Array.isArray(formArrayModel.groups)) {
            formArrayModel.groups.forEach((groupModel: DynamicFormArrayGroupModel) => {
              groupModel.group = this.fromJSON(groupModel.group);
            });
          }

          formArrayModel.groupFactory = () => {
            return this.fromJSON(formArrayModel.groupPrototype);
          };

          model = new DynamicFormArrayModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX:
          model = new DynamicCheckboxModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_CHECKBOX_GROUP:
          modelConfig.group = this.fromJSON(modelConfig.group) as DynamicCheckboxModel[];
          model = new DynamicCheckboxGroupModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_COLORPICKER:
          model = new DynamicColorPickerModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_DATEPICKER:
          // make today the last possible selectable day, unless the config specifies otherwise
          if (modelConfig.max === undefined) {
            modelConfig.max = new Date().toISOString();
          } else if (modelConfig.max instanceof Date) { // Date funktioniert anscheinend nicht - auf ISO String umschreiben
            modelConfig.max = modelConfig.max.toISOString();
          }
          model = new DynamicDatePickerModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_EDITOR:
          model = new DynamicEditorModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_FILE_UPLOAD:
          modelConfig.value = null;
          model = new DynamicFileUploadModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_GROUP:
          modelConfig.group = this.fromJSON(modelConfig.group);
          model = new DynamicFormGroupModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_INPUT:
          const inputModel = modelConfig as DynamicInputModel;

          if (inputModel.mask !== null) {
            if (!((inputModel.mask as any) instanceof Function)) {
              (inputModel.mask as any) = maskFromString(inputModel.mask);
            }
          }

          model = new DynamicInputModel(inputModel, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_RADIO_GROUP:
          model = new DynamicRadioGroupModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_RATING:
          model = new DynamicRatingModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_SELECT:
          addOptionMatcher(modelConfig);
          addDisplayLabels(modelConfig);
          model = new CustomDynamicSelectModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_SLIDER:
          model = new DynamicSliderModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_SWITCH:
          model = new DynamicSwitchModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_TEXTAREA:
          model = new DynamicTextAreaModel(modelConfig, layout);
          break;

        case DYNAMIC_FORM_CONTROL_TYPE_TIMEPICKER:
          model = new DynamicTimePickerModel(modelConfig, layout);
          break;

        case TYPE_CUSTOM_FILE_UPLOAD:
          model = new CustomFileUploadModel(modelConfig, layout);
          break;

        case TYPE_SCHADEN_ANGABE:
          model = new SchadenAngabeModel(modelConfig, layout);
          break;

        case TYPE_DOKUMENTEN_ANGABE:
          model = new DokumentenAngabeModel(modelConfig, layout);
          break;

        case TYPE_CHECKLISTE:
          model = new ChecklisteModel(modelConfig, layout);
          break;

        case TYPE_ACTION_BUTTON:
          model = new ActionButtonModel(modelConfig, layout);
          break;

        case TYPE_INFO:
          model = new InfoComponentModel(modelConfig, layout);
          break;

        case TYPE_ABSCHLUSS:
          model = new AbschlussComponentModel(modelConfig, layout);
          break;

        case TYPE_SELECT_EDIT:
          addOptionMatcher(modelConfig);
          addDisplayLabelFn(modelConfig);
          model = new SelectEditModel(modelConfig, layout);
          break;

        case TYPE_SELECT_FILTER:
          addOptionMatcher(modelConfig);
          addDisplayLabels(modelConfig);
          model = new SelectFilterModel(modelConfig, layout);
          break;

        case TYPE_CHIP_CHOICE_MULTIPLE:
          addOptionMatcher(modelConfig);
          addDisplayLabels(modelConfig);
          model = new ChipChoiceMultipleModel(modelConfig, layout);
          break;

        case TYPE_CHIP_CHOICE_AUTOCOMPLETE:
          addOptionMatcher(modelConfig);
          addDisplayLabels(modelConfig);
          model = new ChipChoiceAutocompleteModel(modelConfig, layout);
          break;

        case TYPE_KONTAKT_ANGABE:
          model = new KontaktAngabeModel(modelConfig, layout);
          break;

        case TYPE_ZAHLUNGSEMPFAENGER:
          model = new ZahlungsempfaengerModel(modelConfig, layout);
          break;

        case TYPE_COLLISION_PICKER:
          model = new CollisionPickerModel(modelConfig, layout);
          break;

        case TYPE_GESCHAEDIGTES_FAHRZEUG:
          model = new GeschaedigtesFahrzeugModel(modelConfig, layout);
          break;

        case TYPE_LENKER_AUSWAEHLEN:
          model = new LenkerAuswaehlenModel(modelConfig, layout);
          break;

        case TYPE_DATA_ARRAY:
          model = new DataArrayModel(modelConfig, layout);
          break;

        case TYPE_EIGENLEISTUNG_TABLE:
          model = new EigenleistungTableModel(modelConfig, layout);
          break;

        case TYPE_GEBAEUDE_SCHADEN:
          model = new GebaeudeSchadenModel(modelConfig, layout);
          break;

        case TYPE_DATE_RANGE_PICKER:
          model = new DateRangePickerModel(modelConfig, layout);
          break;

        case TYPE_INVENTARAUFSTELLUNG_TABLE:
          model = new InventaraufstellungTableModel(modelConfig, layout);
          break;

        case TYPE_SCHADENBETEILIGTER_KONTAKT_ERFASSEN:
          model = new SchadenbeteiligterKontaktErfassenModel(modelConfig, layout);
          break;

        case TYPE_GESCHAEDIGTE_GERAETE_EINFACH:
          model = new GeschaedigteGeraeteEinfachModel(modelConfig, layout);
          break;

        case TYPE_GESCHAEDIGTE_GERAETE_KOMPLEX:
          model = new GeschaedigteGeraeteKomplexModel(modelConfig, layout);
          break;

        case TYPE_FAHRRAD_LISTE:
          model = new FahrradListeModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_PERSONENSCHADEN:
          model = new HaftpflichtPersonenschadenModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_FORDERUNG_AUFSTELLUNG:
          model = new HaftpflichtForderungAufstellungModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_GESCHAEDIGTE_PERSON:
          model = new HaftpflichtGeschaedigtePersonModel(modelConfig, layout);
          break;

        case TYPE_NACHRICHT_REFERENT:
          model = new NachrichtReferentModel(modelConfig, layout);
          break;

        case TYPE_NACHRICHTENVERLAUF:
          model = new NachrichtenverlaufModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_TIERSCHADEN:
          model = new HaftpflichtTierschadenModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_KFZ_SCHADEN:
          model = new HaftpflichtKfzSchadenModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_SACHSCHADEN_HANDY:
          model = new HaftpflichtSachschadenHandyModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_SACHSCHADEN_KABEL_LEITUNG:
          model = new HaftpflichtSachschadenKabelLeitungModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_SACHSCHADEN_WALDARBEITEN:
          model = new HaftpflichtSachschadenWaldarbeitenModel(modelConfig, layout);
          break;

        case TYPE_HAFTPFLICHT_SPRITZ_WALDARBEITEN_AUFSTELLUNG:
          model = new HaftpflichtSpritzWaldarbeitenAufstellungModel(modelConfig, layout);
          break;

        default:
          throw new Error(`unknown form control model type defined on JSON object with id "${modelConfig.id}"`);
      }
      formModel.push(model);
    });

    return formModel;
  }
}

function addOptionMatcher(modelConfig: DynamicSelectModelConfig<any> & { optionMatcher?: string | string[] }): void {
  if (modelConfig.optionMatcher) {
    // If optionMatcher is a string, match with a predefined matcher function. If it's an array, match property keys.
    modelConfig.compareWithFn =
      typeof modelConfig.optionMatcher === 'string'
        ? OPTION_MATCHERS[modelConfig.optionMatcher]
        : Array.isArray(modelConfig.optionMatcher)
          ? compareProps.bind(null, modelConfig.optionMatcher)
          : null;
  }
  // default fallback compareWithFn is fast-deep-equal
  if (typeof modelConfig.compareWithFn !== 'function') {
    modelConfig.compareWithFn = equal;
  }
}

export function addDisplayLabels(modelConfig: CustomDynamicSelectModelConfig<any>): void {
  addDisplayLabelFn(modelConfig);

  if (typeof modelConfig.displayLabelFn === 'function' && Array.isArray(modelConfig.options)) {
    modelConfig.options.forEach(option => {
      option.label = modelConfig.displayLabelFn(option.value);
    });
  }
}

export function addDisplayLabelFn(modelConfig: CustomDynamicSelectModelConfig<any>): void {
  if (modelConfig.displayLabelFnKey) {
    modelConfig.displayLabelFn = DISPLAY_LABEL_FNS[modelConfig.displayLabelFnKey];
  }
}
